import styled from 'styled-components';
import Grid from './Grid';

const EvenColumns = styled(Grid)`
    grid-template-columns: repeat(${props => props.columns ?? 1}, 1fr);
`;

export default EvenColumns;